import util from '../util'

let controller = 'ContaPagadorBoletos'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post']))
